import { connect } from 'react-redux'

import { makeConditionSelector } from 'selectors/feature/conditions'
import { makeConditionSimulationSelector } from 'selectors/feature/simulation'
import { getIsSimulating } from 'selectors/navigator'
import ConditionLabel from './ConditionLabel'

// See comment in LogicSetContainer to understand why we declare makeMapStateToProps here.
const makeMapStateToProps = () => {
  const querySelector = makeConditionSelector()
  const simulationSelector = makeConditionSimulationSelector()

  return (state, ownProps) => {
    const { ignoreCarry = false, selectedId, uri } = ownProps

    const condition = querySelector(state, {
      queryUri: uri,
    })
    const { evaluationResult, edgeEvaluation } = simulationSelector(state, {
      queryUri: uri,
    })
    const isSimulating = getIsSimulating(state)

    const { subType } = condition
    const key = `${uri}-${subType}`
    const isSelected = selectedId === key

    return {
      ...condition,
      uri,
      isSelected,
      ignoreCarry,
      isSimulating,
      evaluationResult,
      edgeEvaluation,
    }
  }
}

export default connect(makeMapStateToProps)(ConditionLabel)
